"use strict";

class SalesPaymentController {

  constructor($scope, $window, SSAppService, SSHttpService, SSUtilService, SSDateService, SSAlertService, $timeout) {
    const self = this;

    self.$scope = $scope;
    self.$window = $window;
    self.SSAppService = SSAppService;
    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSDateService = SSDateService;
    self.SSAlertService = SSAlertService;
    self.$timeout = $timeout;

    self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
    self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
    self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
    self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
    self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
    self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;
    self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
    self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
    self.SALE_STATUS_EXPIRED = SHOWSUITE.SALE_STATUS_EXPIRED;
    self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
    self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
    self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
    self.SALE_STATUS_INVALID = SHOWSUITE.SALE_STATUS_INVALID;
    self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
    self.SALE_STATUS_DELETED = SHOWSUITE.SALE_STATUS_DELETED;

    self.BROKER_ROLE_MAIN_BROKER = SHOWSUITE.BROKER_ROLE_MAIN_BROKER;

    // self.init();
  }

  init() {
    const self = this;

    self.properties = [];
    self.sales = [];
    self.property_id = "";
    self.sale_status = "";
    self.projects = [];
    self.limit = 5;
    self.offset = 0;
    self.sales_total = 0;
    self.prepareDeveloperProperties();
    self.prepareSaleStatuses();
  }

  prepareDeveloperProperties() {
    const self = this;

    let url = 'sec/developer/properties';

    loading(true);
    self.SSHttpService.getAPIRequest(url).then(function (response) {
      loading(false);
      if (response instanceof Error) {          
          self.SSAlertService.parseAndDisplayError(response);
          return;
      }

      self.properties = response.data.properties;

      self.$timeout(function() { $("select.dashboard-select#property-select").niceSelect('update'); });

      self.retrieveApplications();
    });
  }

  displayControls(index, sale) {
    const self = this;

    self.selected_sale = sale;

    let close = true;
    if ($("#control_" + index).hasClass("show")) {
      close = false;
    }

    $(".controls").removeClass("show");

    if (close) {
      $("#control_" + index).toggleClass("show");
    }
  }

  onAcceptConfirm() {
    const self = this;

    let url = 'sec/sales/' + self.selected_sale.id + '/status';
    let params = {
      'status': self.SALE_STATUS_APPROVED
    };

    loading(true);
    self.SSHttpService.putAPIRequest(url, params).then(function (response) {
      loading(false);
      if (response instanceof Error) {
        self.hideModals();
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      //Update sale status
      self.selected_sale.status = self.SALE_STATUS_APPROVED;
      self.SSAlertService.success('Success!', 'Sale is approved successfully.');

      self.onOTP();
    });
  }

  onOTP() {
    const self = this;

    self.hideModals();

    self.showOTPModal = true;
    $('#developerSaleApplicationOTPModal').modal('show');
  }

  onRejectConfirm() {    
    const self = this;

    let url = 'sec/sales/' + self.selected_sale.id + '/status';
    let params = {
      'status': self.SALE_STATUS_REJECTED
    };

    loading(true);
    self.SSHttpService.putAPIRequest(url, params).then(function (response) {
      loading(false);
      self.hideModals();
      if (response instanceof Error) {        
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      //Update sale status
      self.selected_sale.status = self.SALE_STATUS_REJECTED;
      self.SSAlertService.success('Success!', 'Sale is rejected successfully.');
    });
  }

  generateOTP() {
    const self = this;

    self.hideModals();

    let url = 'sec/sales/' + self.selected_sale.id + '/status';
    let params = {
      'status': self.SALE_STATUS_OTP
    };

    loading(true);
    self.SSHttpService.putAPIRequest(url, params).then(function (response) {
      loading(false);
      self.hideModals();
      if (response instanceof Error) {        
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      //Update sale status
      self.selected_sale.status = self.SALE_STATUS_OTP;
      

      //Download OTP form and redirect to OTP form page
      self.linkToOTP();
    });

  }

  linkToOTP() {
    const self = this;
    self.$window.location.href = '/developer/sales/applications' + self.selected_sale.id + '/otp';
  }

  prepareSaleStatuses() {
    const self = this;

    self.sale_statuses = [
      {
        'id': self.SALE_STATUS_VERIFIED,
        'name': 'Pending'
      },
      {
        'id': self.SALE_STATUS_REJECTED,
        'name': 'Rejected'
      },
      {
        'id': self.SALE_STATUS_APPROVED,
        'name': 'Accepted'
      }
    ];

    self.$timeout(function() { $("select.dashboard-select#status-select").niceSelect('update'); });
  }

  onReview() {
    const self = this;

    self.hideModals();

    self.showReview = true;
    $('#developerSaleApplicationReviewModal').modal('show');

  }

  onAccept(sale) {
    const self = this;

    self.hideModals();

    self.showAccept = true;
    $('#developerSaleApplicationAcceptModal').modal('show');
  }

  onReject(sale) {
    const self = this;

    self.hideModals();

    self.showReject = true;
    $('#developerSaleApplicationRejectModal').modal('show');
  }

  hideModals() {
    const self = this;

    self.showReview = false;
    self.showAccept = false;
    self.showReject = false;
    self.showAgent = false;
    self.showBuyer = false;
    self.showOTPModal = false;

    if ($('#developerSaleApplicationReviewModal').is(':visible')) $('#developerSaleApplicationReviewModal').modal('hide');
    if ($('#developerSaleApplicationAcceptModal').is(':visible')) $('#developerSaleApplicationAcceptModal').modal('hide');
    if ($('#developerSaleApplicationRejectModal').is(':visible')) $('#developerSaleApplicationRejectModal').modal('hide');
    if ($('#developerSaleApplicationAgentModal').is(':visible')) $('#developerSaleApplicationAgentModal').modal('hide');
    if ($('#developerSaleApplicationBuyerModal').is(':visible')) $('#developerSaleApplicationBuyerModal').modal('hide');
    if ($('#developerSaleApplicationOTPModal').is(':visible')) $('#developerSaleApplicationOTPModal').modal('hide');
  }

  previousPage() {
    const self = this;

    self.offset = self.offset - parseInt(self.limit);
    self.retrieveApplications();
  }

  nextPage() {
    const self = this;

    self.offset = self.offset + parseInt(self.limit);
    self.retrieveApplications();
  }

  updateFilter() {
    const self = this;

    self.offset = 0;
    self.retrieveApplications();
  }

  onViewSummary(sale) {
    const self = this;

    self.$window.location.href = '/developer/sales/applications/summary?sale_id=' + sale.id;
  }

  retrieveApplications() {
    const self = this;
    self.SSAlertService.message = null

    let status = self.sale_status;
    if (self.sale_status == "") {
      status = self.SALE_STATUS_VERIFIED + ',' + self.SALE_STATUS_REJECTED + ',' + self.SALE_STATUS_OTP + ',' + self.SALE_STATUS_APPROVED;
    } else if (self.sale_status == self.SALE_STATUS_APPROVED) {
      status = self.SALE_STATUS_OTP + ',' + self.SALE_STATUS_APPROVED;
    }

    let url = 'sec/developer/sales';
    let params = {
      'property_id': self.property_id,
      'status': status,
      'limit': self.limit,
      'offset': self.offset,
      'include': 'sale_buyers, brokers, documents, payments, eoi, unit',
      'send_total_count': true
    };

    loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      if (response instanceof Error) {
          loading(false);
          self.SSAlertService.parseAndDisplayError(response);
          return;
      }

      self.sales = response.data.sales;
      self.sales_total = response.data.total_count;

      //Process sales
      $.each(self.sales, function( index, sale ) {
        url = 'brokers/' + sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_MAIN_BROKER).broker_user_id;
        params = {
            'include': 'user, agency'
        };
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            sale['main_broker'] = response.data.brokers[0];
        });

        sale['buyers'] = [];

        $.each(sale.sale_buyers, function(index, buyer) {
          let processed_buyer = JSON.parse(buyer.data);
          sale['buyers'].push(processed_buyer);
        });

        sale['property_name'] = self.properties.find(x => x.id === sale.eoi.property_id).name;

        if (index == self.sales.length - 1) {
          loading(false);
        }
      });

      if (self.sales.length == 0) {
        loading(false);
      }

    });
  }

  showBrokerModal(broker) {
    const self = this;
    self.hideModals();

    self.showAgent = true;

    self.selected_broker = broker;
    $('#developerSaleApplicationAgentModal').modal('show');
  }

  showBuyersModal(buyer) {
    const self = this;
    self.hideModals();

    self.showBuyer = true;
    self.selected_buyer = buyer;
    $('#developerSaleApplicationBuyerModal').modal('show');
  }

}

SalesPaymentController.$inject = ['$scope', '$window', 'SSAppService', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', '$timeout'];
app.controller('SalesPaymentController', SalesPaymentController);